import DashboardHeader from "@/components/DashboardHeader";
import { Button } from "@thdinc/hpf-shared";
import React, { FC } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router";

interface Props {
    previewVisible: boolean;
    onPreviewPress: () => void;
    onBackClick?: () => void;
}

const Header: FC<Props> = ({ onPreviewPress, previewVisible, onBackClick }) => {
    const navigate = useNavigate();
    const handleBack = () => {
        if (onBackClick) {
            onBackClick();
        } else {
            navigate("/events?tab=Leads");
        }
    };
    return (
        <header className="w-full">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                {/* Left: back + title + subtitle */}
                <div className="min-w-0">
                    <div className="flex items-center gap-3 flex-wrap">
                        <button
                            type="button"
                            aria-label="Go back"
                            onClick={handleBack}
                            className="bg-white border rounded-full p-1 hover:bg-gray-50 active:scale-95 transition"
                        >
                            <IoMdArrowBack className="text" />
                        </button>
                        <DashboardHeader title="Quote" />
                    </div>
                </div>
                {/* Right: actions */}
                <div className="flex flex-row flex-wrap justify-center sm:justify-end gap-2 sm:gap-3 md:gap-4 md:shrink-0">
                    {/* View Invoice — visible only on mobile & tablet */}
                    <Button
                        onClick={onPreviewPress}
                        type="button"
                        classes="bg-black text-white flex items-center justify-center gap-2 px-4 py-2 lg:hidden"
                    >
                        {previewVisible ? "Hide Invoice" : "View Invoice"}
                    </Button>
                </div>
            </div>
        </header>
    );
};

export default Header;
